export function createMessage() {
	switch (arguments[0]) {
		case 'auth':
			return JSON.stringify({
				service: 'auth',
				data: {
					session_id: arguments[1],
					login_params: 'orbital.creepycashclassic'
				}
			});
		case 'settings':
			return JSON.stringify({ service: 'settings', data: arguments[1] });

		case 'bet':
			return JSON.stringify({
				service: 'bet',
				data: {
					amount: arguments[1],
					double: arguments[2],
					bonus: arguments[3],
					questid: arguments[4]
				}
			});
		case 'bonusstep':
			return JSON.stringify({
				service: 'bonusstep',
				data: {}
			});
		case 'freespinstep':
			return JSON.stringify({
				service: 'freespinstep',
				data: {}
			});
		default:
			break;
	}
	return;
}
